/*
  Permite buscar si existe el padre de n elemento que cumple la condición que ejecutamos en el callback.
  Ejemplo:
  findParent(el, parent => parent.hasAttribute('buscame'))
*/
export function findParent(elem, callback, max = 30) {
  while (elem && max) {
    max--;
    if (callback(elem)) {
      return elem;
    }
    elem = elem.parentElement;
  }
}
